import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React, { useEffect, useState } from 'react';
import AppCurrencyInput from '@nxsys/components/AppCurrencyInput';

type Props = {
  title?: string;
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: SubmitEPSValues) => Promise<void>;
  defaultValues?: Partial<SubmitEPSValues>;
};

export type SubmitEPSValues = {
  cisDeductionsSuffered: number;
};

const SubmitEPSModal: React.FC<Props> = ({
  title = 'Submit EPS',
  isOpen,
  toggle,
  onSubmit,
  defaultValues = {},
}) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(defaultValues);
    }
  }, [isOpen, defaultValues]);

  const onFinish: FormProps['onFinish'] = (values) => {
    setIsSubmitting(true);
    onSubmit(values)
      .then(() => {
        toggle();
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={title}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: 'Cancel',
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: 'Submit',
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item
          label="CIS Deductions Suffered"
          name="cisDeductionsSuffered"
          rules={[
            {
              required: true,
              message: 'Please enter',
            },
          ]}
        >
          <AppCurrencyInput placeholder="Enter" />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default SubmitEPSModal;
